/**
 * Try to name each action type constant with a namespace that is consistent
 * with its branch of state
 */

// Tasks
export const TASKS_RECEIVE = 'TASKS_RECEIVE'
export const TASKS_MERGE_TODAY = 'TASKS_MERGE_TODAY'
export const TASKS_UPDATE_LISTS = 'TASKS_UPDATE_LISTS'
export const TASKS_PREPEND_TO_LIST = 'TASKS_PREPEND_TO_LIST'
export const TASKS_IS_FETCHING = 'TASKS_IS_FETCHING'
export const TASK_MARK_COMPLETE = 'TASK_MARK_COMPLETE'
export const TASK_MARK_INCOMPLETE = 'TASK_MARK_INCOMPLETE'
export const TASK_MARK_DELETED = 'TASK_MARK_DELETED'

// Conversations
export const CONVERSATIONS_PAGE_NUM = 'CONVERSATIONS_PAGE_NUM'
export const CONVERSATIONS_RECEIVE = 'CONVERSATIONS_RECEIVE'
export const CONVERSATIONS_RECEIVE_NOTIFICATION =
  'CONVERSATIONS_RECEIVE_NOTIFICATION'
export const CONVERSATIONS_RECEIVE_NEXT_PAGE = 'CONVERSATIONS_RECEIVE_NEXT_PAGE'
export const CONVERSATIONS_RECEIVE_LOCATIONS = 'CONVERSATIONS_RECEIVE_LOCATIONS'
export const CONVERSATIONS_UPDATE_ONE = 'CONVERSATIONS_UPDATE_ONE'
export const CONVERSATIONS_UPDATE_SEARCH = 'CONVERSATIONS_UPDATE_SEARCH'
export const CONVERSATIONS_UPDATE_MSG_TYPE = 'CONVERSATIONS_UPDATE_MSG_TYPE'
export const CONVERSATIONS_FETCHING = 'CONVERSATIONS_FETCHING'
export const CONVERSATIONS_FETCHED = 'CONVERSATIONS_FETCHED'

export const CONVERSATIONS_CREATING = 'CONVERSATIONS_CREATING'
export const CONVERSATIONS_ADD_CREATED = 'CONVERSATIONS_ADD_CREATED'
export const CONVERSATIONS_UPDATE_SUBJECT = 'CONVERSATIONS_UPDATE_SUBJECT'
export const CONVERSATIONS_DELETE = 'CONVERSATIONS_DELETE'
export const CONVERSATIONS_ACTIVATE = 'CONVERSATIONS_ACTIVATE'
export const CONVERSATIONS_INACTIVATE = 'CONVERSATIONS_INACTIVATE'

// Messages
export const MESSAGE_LOADING = 'MESSAGE_LOADING'
export const MESSAGES_RECEIVE_IN_BULK = 'MESSAGES_RECEIVE_IN_BULK'
export const MESSAGE_LOADED = 'MESSAGE_LOADED'
export const MESSAGES_ADD_TO_CONVO = 'MESSAGES_ADD_TO_CONVO'
export const MESSAGE_SENDING = 'MESSAGE_SENDING'
export const MESSAGE_APPEND_TO_LIST = 'MESSAGE_APPEND_TO_LIST'
export const MESSAGE_SEND_DONE = 'MESSAGE_SEND_DONE'
export const MESSAGE_RECEIVE_ONE = 'MESSAGE_RECEIVE_ONE'
export const MESSAGE_ADD_MEDIA = 'MESSAGE_ADD_MEDIA'
export const MESSAGE_UPDATE_STATUS = 'MESSAGE_UPDATE_STATUS'

// Current conversation, task, etc
export const CURR_CHOOSE_CONVERSATION = 'CURR_CHOOSE_CONVERSATION'
export const CURR_CONVERSATION_IS_EMAIL = 'CURR_CONVERSATION_IS_EMAIL'
export const CURR_RESET_CONVERSATION = 'CURR_RESET_CONVERSATION'
export const CURR_CONVERSATION_HAS_BODY = 'CURR_CONVERSATION_HAS_BODY'

// Selected patient - patient's page
export const PATIENT_SELECT_RESET = 'PATIENT_SELECT_RESET'
export const PATIENT_SELECT_REQUEST = 'PATIENT_SELECT_REQUEST'
export const PATIENT_SELECT_REQUEST_SUCCESS = 'PATIENT_SELECT_REQUEST_SUCCESS'
export const PATIENT_SELECT_REQUEST_FAILURE = 'PATIENT_SELECT_REQUEST_FAILURE'
export const PATIENT_APPOINTMENTS = 'PATIENT_APPOINTMENTS'
export const PATIENT_REVIEWS = 'PATIENT_REVIEWS'
export const PATIENT_CONVERSATION_REQUEST = 'PATIENT_CONVERSATION_REQUEST'
export const PATIENT_CONVERSATION_REQUEST_SUCCESS =
  'PATIENT_CONVERSATION_REQUEST_SUCCESS'
export const PATIENT_CONVERSATION_REQUEST_FAILURE =
  'PATIENT_CONVERSATION_REQUEST_FAILURE'

export const PATIENT_NOTES_RECEIVE = 'PATIENT_NOTES_REQUEST'
export const PATIENT_NOTES_CREATE = 'PATIENT_NOTES_CREATE'
export const PATIENT_NOTES_UPDATE = 'PATIENT_NOTES_UPDATE'
export const PATIENT_NOTES_DELETE = 'PATIENT_NOTES_DELETE'

export const PATIENT_ADD_MSG_CONTACT_INFO = 'PATIENT_ADD_MSG_CONTACT_INFO'
export const PATIENT_UPDATE_CONVERSATION_IDS = 'PATIENT_UPDATE_CONVERSATION_IDS'

// User Account
export const ACCT_LOGIN_SUCC = 'ACCT_LOGIN_SUCC'
export const ACCT_SET_ACTIVE_LOC = 'ACCT_SET_ACTIVE_LOC'
export const ACCT_CURR_USER = 'ACCT_CURR_USER'
export const ACCT_AUTHORIZATIONS = 'ACCT_AUTHORIZATIONS'
export const ACCT_FETCHING = 'ACCT_FETCHING'
export const ACCT_FETCHED = 'ACCT_FETCHED'
export const ACCT_PREV_URL = 'ACCT_PREV_URL'
export const ACCT_TOGGLE_CALLER_ID = 'ACCT_TOGGLE_CALLER_ID'
export const ACCT_UPDATE_REMAINING_BLAST_MESSAGES =
  'ACCT_UPDATE_REMAINING_BLAST_MESSAGES'
export const ACCT_UPDATE_REMAINING_MMS_MESSAGES =
  'ACCT_UPDATE_REMAINING_MMS_MESSAGES'

// AppointmentTypes
export const APPT_TYPES_LIST = 'APPT_TYPES_LIST'
export const APPT_TYPES_PATCH = 'APPT_TYPES_PATCH'
export const APPT_TYPES_FETCHING = 'APPT_TYPES_FETCHING'
export const APPT_TYPES_FETCHED = 'APPT_TYPES_FETCHED'

// Notifications
export const FETCH_ALL_UNSEEN_CONVOS = 'FETCH_ALL_UNSEEN_CONVOS'
export const ADD_UNSEEN_CONVO = 'ADD_UNSEEN_CONVO'
export const REMOVE_UNSEEN_CONVO = 'REMOVE_UNSEEN_CONVO'

// Message Settings
export const MESSAGE_SETTINGS_RECEIVE = 'MESSAGE_SETTINGS_RECEIVE'
export const MESSAGE_SETTINGS_UPDATE = 'MESSAGE_SETTINGS_UPDATE'
export const MESSAGE_SETTINGS_ACTIVATE = 'MESSAGE_SETTINGS_ACTIVATE'
export const MESSAGE_SETTINGS_DEACTIVATE = 'MESSAGE_SETTINGS_DEACTIVATE'
export const MESSAGE_SETTINGS_CREATE = 'MESSAGE_SETTINGS_CREATE'
export const MESSAGE_SETTINGS_UNDO_DEACTIVATE =
  'MESSAGE_SETTINGS_UNDO_DEACTIVATE'
export const MESSAGE_SETTINGS_SET_REVIEWS_OFFSET =
  'MESSAGE_SETTINGS_SET_REVIEWS_OFFSET'
export const MESSAGE_SETTINGS_SET_SOCIAL_LINKS =
  'MESSAGE_SETTINGS_SET_SOCIAL_LINKS'

// New Patient Groups
export const PATIENTS_GROUPS_SELECT = 'PATIENTS_GROUPS_SELECT'
export const PATIENTS_GROUPS_CHANGE_VIEW = 'PATIENTS_GROUPS_SELECT_CHANGE_VIEW'
export const PATIENTS_GROUPS_REQUEST = 'PATIENTS_GROUPS_REQUEST'
export const PATIENTS_GROUPS_REQUEST_FAILURE = 'PATIENTS_GROUPS_REQUEST_FAILURE'
export const PATIENTS_GROUPS_RECEIVE_PATIENTS =
  'PATIENTS_GROUPS_RECEIVE_PATIENTS'
export const PATIENTS_GROUPS_RECEIVE_GROUPS = 'PATIENTS_GROUPS_RECEIVE_GROUPS'
export const PATIENTS_GROUPS_RECEIVE_PATIENT_APPT_DATA =
  'PATIENTS_GROUPS_RECEIVE_PATIENT_APPT_DATA'
export const PATIENTS_GROUPS_RECEIVE_DOCTORS_AND_LOCATIONS_AND_STATUSES =
  'PATIENTS_GROUPS_RECEIVE_DOCTORS_AND_LOCATIONS_AND_STATUSES'
export const PATIENTS_GROUPS_UPDATE_SEARCH = 'PATIENTS_GROUPS_UPDATE_SEARCH'
export const PATIENTS_GROUPS_UPDATE_ALL_LOCATIONS =
  'PATIENTS_GROUPS_UPDATE_ALL_LOCATIONS'
export const PATIENTS_GROUPS_ADD_STATUS_FILTER =
  'PATIENTS_GROUPS_ADD_STATUS_FILTER'
export const PATIENTS_GROUPS_ADD_APPT_TYPE_FILTER =
  'PATIENTS_GROUPS_ADD_APPT_TYPE_FILTER'

// Blast Messages, Group Messages
export const BLASTS_PREPARE = 'BLASTS_PREPARE'
export const BLASTS_FETCHING = 'BLASTS_FETCHING'
export const BLASTS_FETCH_SUCC = 'BLASTS_FETCH_SUCC'
export const BLASTS_FETCH_FAIL = 'BLASTS_FETCH_FAIL'
export const BLASTS_RECEIVE = 'BLASTS_RECEIVE'

// Call Log
export const COREDIAL_START_FETCHING = 'COREDIAL_START_FETCHING'
export const COREDIAL_SET_CALL_DATA = 'COREDIAL_SET_CALL_DATA'
export const COREDIAL_CLEAR_CALL_DATA = 'COREDIAL_CLEAR_CALL_DATA'
export const COREDIAL_SET_DATE = 'COREDIAL_SET_DATE'
export const COREDIAL_SET_PATIENT_CALL_DATA = 'COREDIAL_SET_PATIENT_CALL_DATA'
export const COREDIAL_SET_CALL_LOG_FILTER = 'COREDIAL_SET_CALL_LOG_FILTER'
export const COREDIAL_SET_POPOVER = 'COREDIAL_SET_POPOVER'
export const COREDIAL_SET_TAB = 'COREDIAL_SET_TAB'
export const COREDIAL_SET_NEW_CONTACT_INFO = 'COREDIAL_SET_NEW_CONTACT_INFO'
export const COREDIAL_SET_MATCHING_CONTACTS = 'COREDIAL_SET_MATCHING_CONTACTS'
export const COREDIAL_START_FETCHING_CONTACTS =
  'COREDIAL_START_FETCHING_CONTACTS'
export const COREDIAL_SET_CONTACTS = 'COREDIAL_SET_CONTACTS'

// Active Hours
export const ACTIVE_HOURS_FETCHING = 'ACTIVE_HOURS_FETCHING';
export const ACTIVE_HOURS_FETCHED = 'ACTIVE_HOURS_FETCHED';
export const ACTIVE_HOURS_UPDATING = 'ACTIVE_HOURS_UPDATING';
export const ACTIVE_HOURS_UPDATED = 'ACTIVE_HOURS_UPDATED';


// WEBPACK FOOTER //
// ./src/state/actions/_types.js